import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { ValidateService } from 'src/app/services/ui/validate.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import { PTableComponent } from '../p-table/p-table.component';

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {

  inProgress = false;
  selectedTab: any;
  product: any = {};
  id: string;
  pid: any;
  loadingPackages = false;
  loadingChannels = false;
  isRefreshing = false;
  loadingSports = false;
  searchPackageSport = '';
  loadingProductType ;
  time = {
    startDate: [0, 0],
    endDate: [0, 0]
  };
  error = {
    name: {
      erc: '1',
      value: ''
    },
    desc: {
      erc: '1',
      value: ''
    },
    type: {
      erc: '1',
      value: ''
    },
    provider: {
      erc: '1',
      value: ''
    },
    code: {
      erc: '1',
      value: ''
    },
  };
  start_date = '';
  end_date = '';
  created =  false;
  allProducts = false;
  image = new FormControl(null, [Validators.required]);
  constructor(public partnerService: PartnerServicesService,
              public userService: UserManagerService,
              private translate: TranslateService,
              private router: Router,
              private helperFunction: HelperFunctions,
              private validateService: ValidateService,
              public dialogRef: MatDialogRef<PTableComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.router.events.subscribe(val => {
      this.onNoClick();
    });
    this.product = this.data.product? this.data.product: {};
    this.pid = this.data.pid ? this.data.pid : undefined;
      // console.log('data',this.userService.logindata);
    this.productTypes();
  }
  setDate(date, key) {
    this.product[key] = Number(new Date(date).getTime());
  }
  changeSelectedItem(item, type) {
    // if ( type === 'package') {
      this.product.pdt_type_id= item.id;
      // console.log('pdt_type ', this.product)
    // } else if (type === 'channel') {
    //   this.product.channelId = item.lgCHANNELID;
    // } else if (type === 'sports') {
    //   this.searchPackageSport = item.name;
    //   // this.loadPackages();
    // }
  }
  updateProduct(){
    if (!this.validateForm()) {
      // console.log('validation failed');
      return;
    }
    let params;
    params={
      id:this.product.id,
      name:this.product.name,
      desc: this.product.desc,
      pdt_type_id: this.product.pdt_type_id,
      uid :this.userService.logindata.info.id,
      pid: this.pid,
      code: this.product.code
    }
    // console.log(params);
    this.partnerService.createProduct(params).then(res =>{
      this.partnerService.checkOperation(res);
      this.product={};
      this.created = true;
      this.onNoClick();
    })
  }

  refresh(type) {
  //   this.isRefreshing = true;
  //   if (type === 'package') {
  //     this.loadPackages();
  //   } else if (type === 'channel') {
  //     this.loadChannels();
  //   } else {
  //     this.loadSports({});
  //   }
  }
  loadMore(searchdata, type) {

      this.loadingPackages = true;

      this.partnerService.loadProductTypes(searchdata, 'load-more').then( _ => {

        this.loadingPackages = false;
      });

    // else if (type === 'sports') {
    //   this.loadSports(searchdata);
    // }

  }
  productTypes(){
    this.loadingPackages = true;
    this.partnerService.loadProductTypes({name: '', page: 0, size: 20, sportName: this.searchPackageSport}, 'load-more')
      .then( _ => {
      }).finally(() => {
        this.loadingPackages = false;
        this.isRefreshing = false;
      });
  }


  setTime(input: HTMLInputElement, key) {
    const hour = Number(input.value.split(':')[0]) + 0;
    const minute = Number(input.value.split(':')[1]) + 0;
    this.time[key] = [hour, minute];
  }
  validateForm() {
    // return true;
    const testFields = this.allProducts
                        ?[  'desc', 'name', 'code']
                        :[   'name', 'desc','code'];
    const result = this.validateService.validateRequiredFields(this.product, testFields);
    this.error.desc = result.data.desc;
    // this.error.type = result.data.type;
    this.error.name = result.data.name;
    // console.log(this.error, result.submit);
    return result.submit;
  }
  onNoClick(): void {
    this.dialogRef.close(this.created);
  }
  newProduct(){
    if (!this.validateForm()) {
      // console.log('validation failed');
      return;
    }
    // console.log('validation success');
  }
}
